export const ACTIONS = {
	CLEAR_STORED_DATA: 'CLEAR_STORED_DATA' as const,
	RESET: 'RESET' as const,
	SET_FIELDS: 'SET_FIELDS' as const,
	SET_LOADING: 'SET_LOADING' as const,
	SET_OVERFLOW_X: 'SET_OVERFLOW_X' as const,
	SET_OVERFLOW_Y: 'SET_OVERFLOW_Y' as const,
	SET_SAVING: 'SET_SAVING' as const,
	SET_STORED_DATA: 'SET_STORED_DATA' as const,
};
